"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "boscoreale": {
    "65c17be5": [{
      "hkey": "5e1384e0",
      "slug": "boscoreale",
      "name": "Boscoreale",
      "primary": true,
      "skipSearch": false
    }],
    "cangiani": [{
      "hkey": "5e1384e0",
      "slug": "boscoreale",
      "name": "Boscoreale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "21960c5b": [{
      "hkey": "5e1384e0",
      "slug": "boscoreale",
      "name": "Boscoreale",
      "primary": true,
      "skipSearch": false
    }],
    "marchesa": [{
      "hkey": "5e1384e0",
      "slug": "boscoreale",
      "name": "Boscoreale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5717ffd3": [{
      "hkey": "5e1384e0",
      "slug": "boscoreale",
      "name": "Boscoreale",
      "primary": true,
      "skipSearch": false
    }],
    "marra": [{
      "hkey": "5e1384e0",
      "slug": "boscoreale",
      "name": "Boscoreale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "70f1dc08": [{
      "hkey": "5e1384e0",
      "slug": "boscoreale",
      "name": "Boscoreale",
      "primary": true,
      "skipSearch": false
    }],
    "pellegrini": [{
      "hkey": "5e1384e0",
      "slug": "boscoreale",
      "name": "Boscoreale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;